import { isEncompass } from '$Utilities/integrationPlatform';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box } from '@mui/material';
import { React, moment } from 'Imports';
import { faCalendarDays } from '@fortawesome/pro-regular-svg-icons';
import classNames from 'classnames';
import * as DateFormatter from '$Components/Shared/DateFormatter';

const styles = require('./DateRangeInput.scss') as {
    container: string;
    inputWrapper: string;
    inputWrapperEncompass: string;
    inputWrapperEncompassMobile: string;
    inputWrapperGeotab: string;
    inputWrapperGeotabMobile: string;
    dateTextContainer: string;
    dateTextContainerEncompass: string;
    dateTextContainerGeotab: string;
    separator: string;
    separatorEncompass: string;
    separatorGeotab: string;
    calendarIconContainer: string;
    calendarIconContainerEncompass: string;
    calendarIconContainerGeotab: string;
    calendarIcon: string;
    calendarIconEncompass: string;
    calendarIconGeotab: string;
    active: string;
    inactive: string;
};

interface IDateRangeInputProps {
    dateRange: { startDate: Date; endDate: Date };
    isActive: boolean;
    onClick: (event: React.MouseEvent<HTMLElement>) => void;
    isMobileView: boolean;
}

export const DateRangeInput: React.FC<IDateRangeInputProps> = (props: IDateRangeInputProps) => {
    const startDateLabel = DateFormatter.date(moment(props.dateRange.startDate));
    const endDateLabel = DateFormatter.date(moment(props.dateRange.endDate));

    const inputWrapperClass = classNames(
        styles.inputWrapper,
        isEncompass
            ? props.isMobileView
                ? styles.inputWrapperEncompassMobile
                : styles.inputWrapperEncompass
            : props.isMobileView
              ? styles.inputWrapperGeotabMobile
              : styles.inputWrapperGeotab,
    );

    const dateTextContainerClass = classNames(
        styles.dateTextContainer,
        isEncompass ? styles.dateTextContainerEncompass : styles.dateTextContainerGeotab,
        props.isActive ? styles.active : styles.inactive,
    );

    const calendarIconClass = classNames(styles.calendarIcon, isEncompass ? styles.calendarIconEncompass : styles.calendarIconGeotab);

    return (
        <Box onClick={props.onClick} className={styles.container}>
            <Box className={inputWrapperClass}>
                {/* Date text container */}
                <Box className={dateTextContainerClass}>
                    {startDateLabel} &ndash; {endDateLabel}
                </Box>

                {/* Separator line (only for Encompass) */}
                {isEncompass && <Box className={styles.separator + ' ' + styles.separatorEncompass} />}

                {/* Calendar icon container */}
                <Box
                    className={classNames(
                        styles.calendarIconContainer,
                        isEncompass ? styles.calendarIconContainerEncompass : styles.calendarIconContainerGeotab,
                        !isEncompass && (props.isActive ? styles.active : styles.inactive),
                    )}
                >
                    <FontAwesomeIcon icon={faCalendarDays} className={calendarIconClass} />
                </Box>
            </Box>
        </Box>
    );
};

export default DateRangeInput;
